import { storeToRefs } from "pinia";
import type { RouteLocationNormalized, RouteRecordRaw } from "vue-router";
import type { AbilitiesEvaluation } from "vue-simple-acl/types/acl";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import { useConfigStore } from "~/core/stores/useConfigStore";
import { canWithRedirection } from "~/core/utils/canWithRedirection";
import { PlatformType } from "~/modules/about/models/PlatformType.enum";
import { PATH_CONNECT_MY_MOBILE_APP } from "~/modules/connectMobileApp/constants";
import ConnectMobileAppPage from "~/modules/connectMobileApp/views/ConnectMobileAppPage.vue";

function canDisplayConnectMyMobileApp() {
  const { platformType } = storeToRefs(useConfigStore());
  return platformType.value !== PlatformType.SAAS;
}

const routes: RouteRecordRaw[] = [
  {
    path: PATH_CONNECT_MY_MOBILE_APP,
    component: ConnectMobileAppPage,
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) =>
        canDisplayConnectMyMobileApp() &&
        canWithRedirection(can, ACLRoles.CAN_READ_APPLICATION),
    },
  },
];

export default routes;
